// extracted by mini-css-extract-plugin
export var root = "VideoPlayer-module--root--ef95a";